import React from 'react';
import PhoneInputComponent from 'react-phone-number-input';

const PhoneInput = ({ value, onChange, defaultCountry, placeholder = 'Enter phone number', style }) => {
  return (
    <PhoneInputComponent
      placeholder={placeholder}
      defaultCountry={defaultCountry}
      addInternationalOption={true}
      limitMaxLength={true}
      style={{
        border: '1px solid #C2C8D6',
        boxSizing: 'border-box',
        height: '57px',
        paddingLeft: '20px',
        marginBottom: '15px',
        borderRadius: '100px',
        width: '100%',
        ...style,
      }}
      value={value}
      numberInputProps={{
        className: 'input-child input-child-2',
      }}
      onChange={onChange}
    />
  );
};

export default PhoneInput;
